import { useEffect, useState } from "react";
import PropTypes from "prop-types";

export default function RotatingTagline({ items, interval = 3800 }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!items || items.length <= 1) return undefined;
    const t = setInterval(() => setIndex((i) => (i + 1) % items.length), interval);
    return () => clearInterval(t);
  }, [items, interval]);

  return (
    <p
      data-testid="hero-rotator"
      className="wt-lead mt-6 max-w-2xl"
      aria-live="polite"
      style={{ minHeight: "3.4em" }}
    >
      {items.map((text, i) => (
        <span
          key={i}
          className="block transition-all duration-500"
          style={{
            opacity: i === index ? 1 : 0,
            transform: i === index ? "translateY(0)" : "translateY(4px)",
            position: i === index ? "relative" : "absolute",
            pointerEvents: i === index ? "auto" : "none",
          }}
        >
          {text}
        </span>
      ))}
    </p>
  );
}

RotatingTagline.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  interval: PropTypes.number,
};
